import { useEffect } from 'react';

type Props = {
  script: string;
};
const GlobalHeaderScript = ({ script }: Props) => {
  useEffect(() => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(script, 'text/html');
    const scriptElement = doc.querySelector('script');
    if (scriptElement) {
      const newScript = document.createElement('script');
      // Copy attributes from the original script element
      Array.from(scriptElement.attributes).forEach((attr) => {
        newScript.setAttribute(attr.name, attr.value);
      });
      newScript.textContent = scriptElement.textContent;
      document.head.appendChild(newScript);
      return () => {
        // Only remove if the script is still a child of document.head
        // This prevents "Failed to execute 'removeChild'" errors during hydration/navigation
        if (document.head.contains(newScript)) {
          document.head.removeChild(newScript);
        }
      };
    }
  }, [script]);

  return null;
};

export default GlobalHeaderScript;
